"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.default = () => (React.createElement("svg", { width: "320", height: "568" },
    React.createElement("defs", null,
        React.createElement("linearGradient", { x1: "50%", y1: "0%", x2: "50%", y2: "100%", id: "message-media-icon-gradient" },
            React.createElement("stop", { stopColor: "#E9E9E9", offset: "0%" }),
            React.createElement("stop", { stopColor: "#EEE", stopOpacity: ".5", offset: "100%" }))),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "url(#message-media-icon-gradient)", d: "M0 0h320v568H0z" }),
        React.createElement("rect", { fill: "#D8D8D8", x: "106", y: "524", width: "108", height: "4", rx: "2" }))));
